import { IBasketItem } from 'lib/basket/types';
import { useBasket } from 'lib/hooks/basket/use-basket';
import currency from 'currency.js';
import { StandardInput } from 'components/forms/input';

interface Props {
  ticketItem: IBasketItem<
    | 'ticket-book'
    | 'ticket-online-book'
    | 'ticket-free'
    | 'ticket-online-free'
    | 'ticket-online-voucher'
    | 'ticket-voucher'
  >;
}

export const TicketBasketItem = ({ ticketItem }: Props) => {
  const [basket, modifyBasket] = useBasket();

  return (
    <article className='grid grid-cols-4 gap-4'>
      <img
        src={ticketItem.data.event.image}
        alt={`image for ${ticketItem.data.event.title}`}
        className='col-span-1'
      />
      <section className='col-span-3 grid grid-cols-2'>
        <header className='col-span-1 mt-auto text-left flex flex-col'>
          <h3 className='line-clamp-2 mt-auto text-base'>
            {ticketItem.data.event.title}
          </h3>
          <span className='text-sm text-gray-600 italic'>
            Unit Price:{' '}
            {currency(ticketItem.data['price'] ?? 0, {
              fromCents: true,
              symbol: '£',
            }).format()}
          </span>
          <span className='text-gray-600 italic text-sm'>
            {ticketItem.type === 'ticket-free'
              ? 'Free Ticket'
              : ticketItem.type === 'ticket-voucher'
              ? 'Voucher for event'
              : ticketItem.type === 'ticket-online-voucher'
              ? 'Voucher for online event'
              : ticketItem.type === 'ticket-online-free'
              ? 'Online Viewing reminder'
              : ticketItem.type === 'ticket-book'
              ? 'Book for event'
              : ticketItem.type === 'ticket-online-book'
              ? 'Book for online event'
              : 'Voucher'}
          </span>
        </header>
        <button
          className='col-span-1 ml-auto text-xs text-red-default hover:underline mb-auto'
          onClick={() => modifyBasket({ type: 'remove', payload: ticketItem })}>
          remove
        </button>
        {ticketItem.type !== 'ticket-online-free' &&
          ticketItem.type !== 'ticket-free' &&
          ticketItem.type !== 'ticket-online-voucher' && (
            <StandardInput
              label='Quantity'
              type='number'
              name={`item_${ticketItem.id}_quantity`}
              id={`item_${ticketItem.id}_quantity`}
              bind={{
                value: ticketItem.data.quantity,
                onChange: (e) =>
                  modifyBasket({
                    type: 'adjust',
                    payload: {
                      ...ticketItem,
                      data: {
                        ...ticketItem.data,
                        quantity: parseInt(e.target.value),
                      },
                    },
                  }),
              }}
              className='col-span-1 mt-auto text-left'
            />
          )}

        <div className='col-span-1 col-start-2'>
          <dl className='flex flex-col justify-end w-full h-full'>
            <dt className='ml-auto mt-auto'>Total:</dt>
            <dd className='font-bold lining-nums ml-auto '>
              {currency(
                (ticketItem.data['price'] ?? 0) * ticketItem.data.quantity,
                {
                  fromCents: true,
                  symbol: '£',
                }
              ).format()}
            </dd>
          </dl>
        </div>
      </section>
    </article>
  );
};
